import type { FaireProductEntity } from "../../entity_types/product";

export const p_267fzzhmrr: FaireProductEntity = {
  token: "p_267fzzhmrr",
  type: "product",
  name: 'Golden Sheen Obsidian Wolf Carving | Stone Pendant Decor 2"',
  brandToken: "b_gbfbknczne",
  brandName: "Crystal Deal· Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/84036ce770e90e6c5cf732848e14b1801517521d40f3b03c02c7295aeb7fe5be.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7efde5f41f21c425ad2d5f35ae4d2d637c33de5c4a2db0036778950b3beff3bf.jpeg",
  ],
  priceDollars: 11.09,
  description:
    'Small hand-carved wolf design made from natural golden sheen obsidian. Features a smooth, polished surface and subtle metallic sheen. Suitable for use as a stone pendant, jewelry accent, or small display piece.\n\nNatural golden sheen obsidian\nHand-carved wolf design\nSmooth polished finish\nSuitable for pendant or small display use\nSold individually\nApprox. 5 cm (about 2")\n\nNatural variations in sheen, pattern, and carving details are expected. Necklace cord or chain not included unless specified.',
  tags: [],
  msrpDollars: 22.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:04.751Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
